var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"callback"}},[_c('h1',[_vm._v("Votre commande a bien été prise en compte. Merci pour votre confiance.")])])}]

export { render, staticRenderFns }